import { css } from "styled-components";
import { MixinIcon, MixinIconReversable } from "../common";
export const riotStyle = (chroma, paletteTokens) => css `
  &.icon-link {
    ${MixinIcon({ icon: chroma.icons.link, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-accordionPlus {
    ${MixinIcon({ icon: chroma.icons.accordionPlus, color: paletteTokens.bladetext1 })};
  }

  &.icon-accordionMinus {
    ${MixinIcon({ icon: chroma.icons.accordionMinus, color: paletteTokens.bladetext1 })};
  }

  &.icon-arrowRight {
    ${MixinIcon({ icon: chroma.icons.arrowRight, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-arrowLeft {
    ${MixinIcon({ icon: chroma.icons.arrowLeft, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
  }

  &.icon-carouselLeft {
    ${MixinIcon({ icon: chroma.icons.arrowLeft, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
    width: 10em;
    height: 10em;
  }

  &.icon-carouselRight {
    ${MixinIcon({ icon: chroma.icons.arrowRight, color: paletteTokens.bladetext1 })};
    ${MixinIconReversable};
    width: 10em;
    height: 10em;
  }

  &.icon-dropdown {
    ${MixinIcon({ icon: chroma.icons.dropdown, color: paletteTokens.bladetext1 })};
  }

  &.icon-search {
    ${MixinIcon({ icon: chroma.icons.search, color: paletteTokens.bladetext1 })};
  }

  &.icon-action-play-video {
    ${MixinIcon({ icon: chroma.icons.player, color: paletteTokens.bladetext1 })};
    background-color: #f1f5f1;
  }

  &.icon-close {
    ${MixinIcon({ icon: chroma.icons.close, color: paletteTokens.bladetext1 })};
    width: 3em;
    height: 3em;
  }

  &.icon-platformWindows {
    ${MixinIcon({ icon: chroma.icons.platformWindows, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformMac {
    ${MixinIcon({ icon: chroma.icons.platformMac, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformIos {
    ${MixinIcon({ icon: chroma.icons.platformIos, color: paletteTokens.bladetext1 })};
  }

  &.icon-platformAndroid {
    ${MixinIcon({ icon: chroma.icons.platformAndroid, color: paletteTokens.bladetext1 })};
  }

  &.icon-marqueeArrowRight {
    width: 40px;
    height: 55px;

    ${chroma.mediaQueries.tabletDown} {
      height: 32px;
      width: 24px;
    }
    ${MixinIcon({ icon: chroma.icons.marqueeArrowRight, color: paletteTokens.bladetext1 })};
  }
`;
//# sourceMappingURL=index.js.map